import _ from 'lodash';
import {mesh} from 'topojson-client';
import {topology} from 'topojson-server';
import * as ActionTypes from '../actions/actionTypes';
import layers from '../config/boundaries';

const initialState = { layers: _.sortBy(layers, ['display_name']) };

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.TOGGLE_BOUNDARY:
      const newLayers = state.layers.map((value) => {
        const newLayer = { ...value };
        if (value.prefix === action.layer_prefix) {
          newLayer.active = !value.active;
        }
        return newLayer;
      });
      return {
        layers: newLayers
      };

    case ActionTypes.ACTIVATE_BOUNDARY: {
      const newLayers = state.layers.map((value) => {
        const newLayer = { ...value };
        if (value.prefix === action.layer_prefix) {
          newLayer.active = true;
        }
        return newLayer;
      });
      return {
        layers: newLayers
      };
    }

    case ActionTypes.POPULATE_BOUNDARY_DATA: {
      const newLayers = state.layers.map((value) => {
        const newLayer = { ...value };
        if (value.prefix === action.layer_prefix) {
          newLayer.geojson = action.geojson;
          // The topo mesh simplifies the boundaries that share borders, which makes the dashed lines work.
          // But the polygon properties are lost.
          newLayer.topomesh = mesh(topology([action.geojson]));
        }
        return newLayer;
      });
      return {
        layers: newLayers
      };
    }

    case ActionTypes.RESET_LAYERS:
      return { ...initialState };

    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/boundaries.js